import * as ko from 'knockout';

export default class Cylindo {
    private scriptSrc: string = '//viewer.cylindo.com/v4/viewer.min.js';
    private styleSrc: string = '//viewer.cylindo.com/v4/viewer.min.css';
    public static viewers: any[] = [];
    public static framework: any = null;

    private static imageDetailsGrid: any[] = [];

    //TODO: Move to dw setting
    public static cylindoDetailsMap: any[] = [
        {
            width: 1200,
            height: 1200,
            crop: false,
            custom: false,
            type: 'image',
            frame: 25
        },
        {
            width: 1200,
            height: 1200,
            crop: false,
            custom: false,
            type: 'image',
            frame: 22
        },
        {
            width: 1200,
            height: 1200,
            crop: [1745,1364,520,520],
            custom: false,
            type: 'image',
            frame: 28
        },
        {
            width: 1200,
            height: 1200,
            crop: [2615,567,1080,1080],
            custom: false,
            type: 'image',
            frame: 28
        },
        {
            width: 1200,
            height: 1200,
            crop: false,
            custom: false,
            type: 'image',
            frame: 1
        },

    ]

    private static isDebug(){
        return location.host.indexOf('localhost') > -1 || location.host.indexOf('staging') > -1;
    }

    private static getCylindoAreaSettings() {
        const domCylindoSettings = document.querySelector('.js-cylindo-area-settings');
        let cylindoSettings = {};
        if (domCylindoSettings !== null) {
            cylindoSettings = domCylindoSettings.getAttributeNames().reduce((obj, name) => {
                if (name.startsWith('data-')) {
                    if (name.endsWith('translations')) {
                        return {
                            ...obj,
                            [name.slice(name.indexOf('-') + 1)]: JSON.parse(domCylindoSettings.getAttribute(name))
                        };
                    }
                    return {...obj, [name.slice(name.indexOf('-') + 1)]: domCylindoSettings.getAttribute(name)};
                }
                return obj;
            }, {});
        }
        return cylindoSettings;
    }

    private static accountId(): number {
        let cylindoSettings = Cylindo.getCylindoAreaSettings();
        return cylindoSettings['accountid'];
    }

    private static getTranslations(opts): object {
        let cylindoSettings = Cylindo.getCylindoAreaSettings();
        const translations = cylindoSettings['translations'];
        Object.keys(translations).forEach((translationKey) => {
            opts[translationKey] = translations[translationKey];
        });
        return opts;
    }

    public static handleSplideJSCarousel = (instanceName, opts) => {
        //handle multiple containers - product carousel
        Array.from(document.getElementsByClassName("js-cylindo-main-container-target-container")).forEach((element, index) => {
            let parentId = element.id;
            let cylindoMainContainerTarget = element.querySelectorAll(".js-cylindo-main-container-target")[0];
            if (cylindoMainContainerTarget) {
                cylindoMainContainerTarget.id = parentId + "-content";
                opts.containerID = cylindoMainContainerTarget.id;
                Cylindo.viewers[instanceName + index] = Cylindo.framework.viewer.create(opts);
                Cylindo.setInstanceConfiguration((instanceName + index), opts);

                // When viewer is completed rotate it
                Cylindo.viewers[instanceName + index].on(Cylindo.viewers[instanceName + index].events.VIEWER_COMPLETE, function(evt, data) {
                    // rotate function executed to rotate the viewer 360 degrees in 1 sec (1000 ms)
                    Cylindo.viewers[instanceName + index].rotate(360, 1000);
                });

                //set carousel thumbnail
                Cylindo.viewers[instanceName + index].on(Cylindo.viewers[instanceName + index].events.FIRST_FRAME_READY, () => {
                    let slideIdArr = parentId.split('-');
                    let slideId = "";
                    if(slideIdArr.length > 1 && slideIdArr[1].startsWith('slide')) {
                        slideId = slideIdArr[1];
                        let thumbContainer = document.getElementById('splide01-' + slideId).querySelectorAll(".js-cylindo-main-container-thumbnail-target")[0];
                        let firstFrame = cylindoMainContainerTarget.querySelectorAll('.cylindo-viewer-frame-1')[0];
                        if(firstFrame) {
                            let image = firstFrame.getElementsByTagName("img")[0]
                            if(image) {
                                thumbContainer.src = image.src;
                                thumbContainer.classList.remove("tw-hidden");
                            }
                        }
                    }
                });
            }
        });
    }

    public static addViewer(opts: object, instanceName: string) {
        opts = Cylindo.getTranslations(opts);
        opts['accountID'] = Cylindo.accountId();
        //opts['format'] = 'png';
        Cylindo.viewers[instanceName] = Cylindo.framework.viewer.create(opts);
        if(opts.containerID === 'cylindo-main-container') {
            this.handleSplideJSCarousel(instanceName, opts);
        }
        Cylindo.setInstanceConfiguration(instanceName, opts);
        if(opts.rotate === true){
            Cylindo.viewers[instanceName].on(Cylindo.viewers[instanceName].events.VIEWER_READY, function() {
                Cylindo.viewers[instanceName].rotate(360, 1000);
            });
        }

    }

    public static setFeatures(features: string[], instanceName: string) {
        if(instanceName === 'cylindoMainContainer') {
            for(let instance in Cylindo.viewers) {
                if(instance.startsWith('cylindoMainContainer')) {
                    Cylindo.viewers[instance].setFeatures(features);
                }
            };
        } else {
            Cylindo.viewers[instanceName].setFeatures(features);
        }
        if(Cylindo.isDebug()){
            console.log('set features', features, Cylindo.viewers[instanceName]);
        }

    }

    public static getFeatures(instanceName: string) {
        if(Cylindo.isDebug()){
            console.log('get features', Cylindo.viewers[instanceName].getFeatures());
        }
        return Cylindo.viewers[instanceName].getFeatures();
    }

    public static verifyFeatures(features: string[], instanceName: string) {
        let returnValue: string[] = [];
        const possibleFeatureKeys = Cylindo.viewers[instanceName].featureKeys;

        for (let i = 0; i < features.length; i += 2) {
            if (possibleFeatureKeys.indexOf(features[i].toLowerCase()) > -1) {
                returnValue.push(features[i]);
                returnValue.push(features[i + 1]);
            }
        }
        return returnValue;
    }

    public static getDefaultFeatureCode(featureKey: string, instanceName: string){
        let defaultFeatureCode ='';
        if(Cylindo.viewers[instanceName] !== undefined){
            const feature = Cylindo.viewers[instanceName].configuration.features.find(f => f.code === featureKey);
            if(feature && feature.options){
                let defaultFeature = feature.options.find(o => o.isDefault === true);
                if (defaultFeature === undefined) {
                    defaultFeature = feature.options[0];
                }

                defaultFeatureCode = defaultFeature.code;
            }
        }

        if(Cylindo.isDebug()){
            console.log('get default feature code', featureKey, defaultFeatureCode);
        }

        return defaultFeatureCode;
    }

    public static setInstanceConfiguration(instanceName, opts) {
        const productCode = Cylindo.viewers[instanceName].getProduct();
        const url = `//content.cylindo.com/api/v2/${Cylindo.accountId()}/products/${productCode}/configuration`;
        fetch(url)
            .then((response) => response.json())
            .then((json) => {
                Cylindo.viewers[instanceName].configuration = json;
                Cylindo.viewers[instanceName].featureTemplates = json.features.map((feature) => {
                    return feature.options.map((option) => {
                        return `${feature.code}:${option.code}`;
                    });
                });
                Cylindo.viewers[instanceName].featureKeys = json.features.map((feature) => {
                    return feature.code.toLowerCase();
                });

            });
    }

    public static getDefaultOverrideFeatureOptions(instanceName, cylindoFeatureCode){
        const instanceConfig = Cylindo.viewers['cylindoMainContainer'].configuration;
        const feature = instanceConfig.features.find(f => f.code === cylindoFeatureCode);
        let returnValue = [];
        if(feature !== undefined && feature.options.length > 0){
            returnValue = feature.options;
        }
        return returnValue;
    }

    public static instanceConfigurationReady(instanceName) {
        return new Promise((resolve) => {
            let interval = setInterval(() => {
                if (Cylindo.viewers[instanceName].configuration) {
                    clearInterval(interval);
                    resolve(Cylindo.viewers[instanceName].configuration);
                }
            }, 100);
        });
    }

    public static getDetailsGrid(features: string[], productCode: string, gridData: string[]) {
        let returnValue: string[] = [];
        Cylindo.imageDetailsGrid = [];

        const instanceConfig = Cylindo.viewers['cylindoMainContainer'].configuration;
        const position = instanceConfig.features.find(f => f.code === 'POSITION');


        let queryString: string = '';
        if (features.length) {
            for (let i = 0; i < features.length; i += 2) {
                if (features[i] !== undefined && features[i + 1] !== undefined) {
                    queryString += `feature=${features[i]}:${features[i + 1]}&`;
                }

            }
        }

        if (position !== undefined) {
            let defaultPositionCode = Cylindo.getDefaultFeatureCode("POSITION", "cylindoMainContainer");
            let nextPosition = position.options.filter(o => o.code !== defaultPositionCode);
            if (nextPosition.length > 0) {
                queryString += `feature=POSITION:${nextPosition[0].code}`;
                Cylindo.imageDetailsGrid.push({
                    width: 1200,
                    height: 1200,
                    crop: false,
                    custom: true,
                    type: 'image',
                    url: `https://content.cylindo.com/api/v2/${Cylindo.accountId()}/products/${productCode}/frames/1/${productCode}.webp?${queryString}&size=800`
                });
            }
        }

        Cylindo.cylindoDetailsMap.forEach((cylindoShoot) =>{
            Cylindo.imageDetailsGrid.push(cylindoShoot);
        });

        gridData.forEach((contentObj: any) => {

            Cylindo.imageDetailsGrid.push({
                width: 1200,
                height: 1200,
                crop: false,
                custom: true,
                type: contentObj.type,
                url: contentObj.src
            });

        });

        Cylindo.imageDetailsGrid.forEach((opt: any) => {
            if (!opt.custom) {
                const croppedQuery: string = opt.crop ? `crop=(${opt.crop.join(',')})&` : `size=(${opt.width},${opt.height})&`;
                opt.url = `https://content.cylindo.com/api/v2/${Cylindo.accountId()}/products/${productCode}/frames/${opt.frame}/${productCode}.webp?${croppedQuery}${queryString}`;
            }
            returnValue.push(opt);
        });

        return returnValue;
    }

    public static isReady() {
        return new Promise((resolve) => {
            let interval = setInterval(() => {
                if (Cylindo.framework) {
                    clearInterval(interval);
                    resolve(Cylindo.framework);
                }
            }, 100);
        });
    }

    private loadCylindoAssets() {
        const scriptPromise = new Promise((resolve, reject) => {
            let script = document.createElement('script');
            document.body.appendChild(script);
            script.onload = resolve;
            script.onerror = reject;
            script.async = true;
            script.src = this.scriptSrc;
        });

        const stylePromise = new Promise((resolve, reject) => {
            let style = document.createElement('link');
            style.rel = 'stylesheet';
            style.href = this.styleSrc;
            style.onload = resolve;
            style.onerror = reject;
            document.head.append(style);
        });


        Promise.all([scriptPromise, stylePromise]).then(() => {
            window['cylindo'].on('ready', () => {
                Cylindo.framework = window['cylindo'];

            });
        });
    }


    constructor() {
        if (document.getElementById('cylindo-main-container') !== null || document.getElementsByClassName("js-productcarousel-is-using-cyldino-assets").length > 0) {
            this.loadCylindoAssets();
        }
    }
}
ko.bindingHandlers['cylindo'] = new Cylindo();
